import { type PropsWithChildren, useCallback, useState } from 'react';

import { DrogasAntiEpileticasContext } from './context';
import {
  EEpilepsyType,
  EPatientType,
  type ICombination,
  type IFirstLineDrug,
  type IGetDrugsInputData,
} from './IUseDrogasAntiEpileticas';

const database: {
  [key: string]: {
    [key: string]: IFirstLineDrug[];
  };
} = {
  '1': {
    '1': [
      {
        id: 1,
        name: 'Valproato',
      },
      {
        id: 2,
        name: 'Divalproato',
      },
      {
        id: 3,
        name: 'Lamotrigina',
      },
    ],
    '2': [
      {
        id: 4,
        name: 'Valproato',
      },
      {
        id: 5,
        name: 'Divalproato',
      },
      {
        id: 6,
        name: 'Etossuximida',
      },
      {
        id: 7,
        name: 'Lamotrigina',
      },
    ],
    '3': [
      {
        id: 8,
        name: 'Valproato',
      },
      {
        id: 9,
        name: 'Divalproato',
      },
    ],
    '4': [
      {
        id: 10,
        name: 'Carbamazepina',
      },
      {
        id: 11,
        name: 'Oxcarbazepina',
      },
      {
        id: 12,
        name: 'Fenitoína',
      },
    ],
    '5': [
      {
        id: 13,
        name: 'Carbamazepina',
      },
      {
        id: 14,
        name: 'Oxcarbazepina',
      },
    ],
    '6': [
      {
        id: 15,
        name: 'Carbamazepina',
      },
      {
        id: 16,
        name: 'Oxcarbazepina',
      },
      {
        id: 17,
        name: 'Fenitoína',
      },
      {
        id: 18,
        name: 'Valproato',
      },
    ],
    '7': [
      {
        id: 19,
        name: 'Valproato',
      },
      {
        id: 20,
        name: 'Divalproato',
      },
      {
        id: 21,
        name: 'Lamotrigina',
      },
    ],
    '8': [
      {
        id: 22,
        name: 'Valproato',
      },
      {
        id: 23,
        name: 'Divalproato',
      },
      {
        id: 24,
        name: 'Lamotrigina',
      },
    ],
    '9': [
      {
        id: 25,
        name: 'Valproato',
      },
      {
        id: 26,
        name: 'Divalproato',
      },
    ],
  },
  '2': {
    '1': [
      {
        id: 27,
        name: 'Divalproato',
      },
      {
        id: 28,
        name: 'Valproato',
      },
      {
        id: 29,
        name: 'Lamotrigina',
      },
    ],
    '2': [
      {
        id: 30,
        name: 'Divalproato',
      },
      {
        id: 31,
        name: 'Valproato',
      },
      {
        id: 32,
        name: 'Lamotrigina',
      },
    ],
    '3': [
      {
        id: 33,
        name: 'Divalproato',
      },
      {
        id: 34,
        name: 'Valproato',
      },
    ],
    '4': [
      {
        id: 35,
        name: 'Oxcarbazepina',
      },
      {
        id: 36,
        name: 'Carbamazepina',
      },
    ],
    '5': [
      {
        id: 37,
        name: 'Oxcarbazepina',
      },
      {
        id: 38,
        name: 'Carbamazepina',
      },
    ],
    '6': [
      {
        id: 39,
        name: 'Oxcarbazepina',
      },
      {
        id: 40,
        name: 'Carbamazepina',
      },
    ],
    '7': [
      {
        id: 41,
        name: 'Divalproato',
      },
      {
        id: 42,
        name: 'Valproato',
      },
      {
        id: 43,
        name: 'Lamotrigina',
      },
    ],
    '8': [
      {
        id: 44,
        name: 'Divalproato',
      },
      {
        id: 45,
        name: 'Valproato',
      },
      {
        id: 46,
        name: 'Lamotrigina',
      },
    ],
    '9': [
      {
        id: 47,
        name: 'Divalproato',
      },
      {
        id: 48,
        name: 'Valproato',
      },
    ],
  },
  '3': {
    '1': [
      {
        id: 49,
        name: 'Valproato',
      },
      {
        id: 50,
        name: 'Divalproato',
      },
    ],
    '2': [
      {
        id: 51,
        name: 'Valproato',
      },
      {
        id: 52,
        name: 'Divalproato',
      },
    ],
    '3': [
      {
        id: 53,
        name: 'Valproato',
      },
      {
        id: 54,
        name: 'Divalproato',
      },
    ],
    '4': [
      {
        id: 55,
        name: 'Oxcarbazepina',
      },
      {
        id: 56,
        name: 'Carbamazepina',
      },
    ],
    '5': [
      {
        id: 57,
        name: 'Oxcarbazepina',
      },
      {
        id: 58,
        name: 'Carbamazepina',
      },
    ],
    '6': [
      {
        id: 59,
        name: 'Oxcarbazepina',
      },
      {
        id: 60,
        name: 'Carbamazepina',
      },
    ],
    '7': [
      {
        id: 61,
        name: 'Valproato',
      },
      {
        id: 62,
        name: 'Divalproato',
      },
    ],
    '8': [
      {
        id: 63,
        name: 'Valproato',
      },
      {
        id: 64,
        name: 'Divalproato',
      },
    ],
    '9': [
      {
        id: 65,
        name: 'Valproato',
      },
      {
        id: 66,
        name: 'Divalproato',
      },
    ],
  },
  '4': {
    '1': [
      {
        id: 67,
        name: 'Divalproato',
      },
      {
        id: 68,
        name: 'Lamotrigina',
      },
      {
        id: 69,
        name: 'Valproato',
      },
    ],
    '2': [
      {
        id: 70,
        name: 'Divalproato',
      },
      {
        id: 71,
        name: 'Lamotrigina',
      },
      {
        id: 72,
        name: 'Valproato',
      },
    ],
    '3': [
      {
        id: 73,
        name: 'Divalproato',
      },
      {
        id: 74,
        name: 'Valproato',
      },
    ],
    '4': [
      {
        id: 75,
        name: 'Oxcarbazepina',
      },
      {
        id: 76,
        name: 'Carbamazepina',
      },
    ],
    '5': [
      {
        id: 77,
        name: 'Oxcarbazepina',
      },
      {
        id: 78,
        name: 'Carbamazepina',
      },
    ],
    '6': [
      {
        id: 79,
        name: 'Oxcarbazepina',
      },
      {
        id: 80,
        name: 'Carbamazepina',
      },
    ],
    '7': [
      {
        id: 81,
        name: 'Divalproato',
      },
      {
        id: 82,
        name: 'Lamotrigina',
      },
      {
        id: 83,
        name: 'Valproato',
      },
    ],
    '8': [
      {
        id: 84,
        name: 'Divalproato',
      },
      {
        id: 85,
        name: 'Lamotrigina',
      },
      {
        id: 86,
        name: 'Valproato',
      },
    ],
    '9': [
      {
        id: 87,
        name: 'Divalproato',
      },
      {
        id: 88,
        name: 'Valproato',
      },
    ],
  },
  '5': {
    '1': [
      {
        id: 89,
        name: 'Divalproato',
      },
      {
        id: 90,
        name: 'Valproato',
      },
      {
        id: 91,
        name: 'Lamotrigina',
      },
    ],
    '2': [
      {
        id: 92,
        name: 'Divalproato',
      },
      {
        id: 93,
        name: 'Valproato',
      },
      {
        id: 94,
        name: 'Lamotrigina',
      },
    ],
    '3': [
      {
        id: 95,
        name: 'Divalproato',
      },
      {
        id: 96,
        name: 'Valproato',
      },
    ],
    '4': [
      {
        id: 97,
        name: 'Oxcarbazepina',
      },
      {
        id: 98,
        name: 'Carbamazepina',
      },
    ],
    '5': [
      {
        id: 99,
        name: 'Oxcarbazepina',
      },
      {
        id: 100,
        name: 'Carbamazepina',
      },
    ],
    '6': [
      {
        id: 101,
        name: 'Oxcarbazepina',
      },
      {
        id: 102,
        name: 'Carbamazepina',
      },
    ],
    '7': [
      {
        id: 103,
        name: 'Divalproato',
      },
      {
        id: 104,
        name: 'Valproato',
      },
      {
        id: 105,
        name: 'Lamotrigina',
      },
    ],
    '8': [
      {
        id: 106,
        name: 'Divalproato',
      },
      {
        id: 107,
        name: 'Valproato',
      },
      {
        id: 108,
        name: 'Lamotrigina',
      },
    ],
    '9': [
      {
        id: 109,
        name: 'Divalproato',
      },
      {
        id: 110,
        name: 'Valproato',
      },
    ],
  },
  '6': {
    '1': [
      {
        id: 111,
        name: 'Divalproato',
      },
      {
        id: 112,
        name: 'Valproato',
      },
      {
        id: 113,
        name: 'Lamotrigina',
      },
    ],
    '2': [
      {
        id: 114,
        name: 'Divalproato',
      },
      {
        id: 115,
        name: 'Valproato',
      },
      {
        id: 116,
        name: 'Lamotrigina',
      },
    ],
    '3': [
      {
        id: 117,
        name: 'Divalproato',
      },
      {
        id: 118,
        name: 'Valproato',
      },
    ],
    '4': [
      {
        id: 119,
        name: 'Oxcarbazepina',
      },
      {
        id: 120,
        name: 'Carbamazepina',
      },
    ],
    '5': [
      {
        id: 121,
        name: 'Oxcarbazepina',
      },
      {
        id: 122,
        name: 'Carbamazepina',
      },
    ],
    '6': [
      {
        id: 123,
        name: 'Oxcarbazepina',
      },
      {
        id: 124,
        name: 'Carbamazepina',
      },
    ],
    '7': [
      {
        id: 125,
        name: 'Divalproato',
      },
      {
        id: 126,
        name: 'Valproato',
      },
      {
        id: 127,
        name: 'Lamotrigina',
      },
    ],
    '8': [
      {
        id: 128,
        name: 'Divalproato',
      },
      {
        id: 129,
        name: 'Valproato',
      },
      {
        id: 130,
        name: 'Lamotrigina',
      },
    ],
    '9': [
      {
        id: 131,
        name: 'Divalproato',
      },
      {
        id: 132,
        name: 'Valproato',
      },
    ],
  },
};

const combinations: {
  [key: string]: ICombination;
} = {
  Carbamazepina: {
    drugs: 'Valproato, Divalproato, Clobazam, Lamotrigina',
    observation:
      'Não associar com fenitoína.\nCarbamazepina pode piorar epilepsia de ausência e mioclônica.\nCategoria de risco D na gravidez. O benefício potencial do fármaco deve ser cuidadosamente avaliado contra seus riscos potenciais de malformações fetais.\nApesar dos riscos, o Consenso dos Especialistas Brasileiros (2003) recomenda a Oxarcarbazepina ou a Carbamazepina como primeira linha de tratamento para epilepsia focal sintomática em pacientes grávidas ou amamentando.',
    posologia: '600-1.600 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 200mg ou 400mg | xp. 20mg/mL',
  },
  Fenitoína: {
    drugs: 'Clobazam, Valproato,  Divalproato,  Lamotrigina',
    observation:
      'Não associar com carbamazepina.\nFenitoína pode piorar epilepsia de ausência e mioclônica.',
    posologia: '200-300 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 100mg',
  },
  Valproato: {
    drugs: 'Clobazam, Lamotrigina',
    observation:
      'Categoria de risco D na gravidez. O benefício potencial do fármaco deve ser cuidadosamente avaliado contra seus riscos potenciais de malformações fetais.\nApesar dos riscos, o Consenso dos Especialistas Brasileiros (2003) recomenda o Valproato, Divalproato ou Lamotrigina como segunda linha de tratamento para epilepsia generalizada idiopática em pacientes grávidas ou amamentando.',
    posologia: '500-2.500 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 250mg ou 500mg | xp. 50mg/mL',
  },
  Divalproato: {
    drugs: 'Clobazam, Valproato,  Divalproato,  Lamotrigina',
    observation:
      'Categoria de risco D na gravidez. O benefício potencial do fármaco deve ser cuidadosamente avaliado contra seus riscos potenciais de malformações fetais.\nApesar dos riscos, o Consenso dos Especialistas Brasileiros (2003) recomenda o Valproato, Divalproato ou Lamotrigina como segunda linha de tratamento para epilepsia generalizada idiopática em pacientes grávidas ou amamentando.',
    posologia: '500-2.500 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 250mg ou 500mg',
  },
  Lamotrigina: {
    drugs: '',
    observation:
      'Categoria de risco C na gravidez. O benefício potencial do fármaco deve ser cuidadosamente avaliado contra seus riscos potenciais de malformações fetais.\nApesar dos riscos, o Consenso dos Especialistas Brasileiros (2003) recomenda o Valproato, Divalproato ou Lamotrigina como segunda linha de tratamento para epilepsia generalizada idiopática em pacientes grávidas ou amamentando.',
    posologia: '100-400 mg/dia, dividido em 1-2x/dia',
    presentation: 'comp. 25mg ou 50mg ou 100mg',
  },
  Oxcarbazepina: {
    drugs: '',
    observation:
      'Não associar com fenitoína.\nCategoria de risco C na gravidez. O benefício potencial do fármaco deve ser cuidadosamente avaliado contra seus riscos potenciais de malformações fetais.\nApesar dos riscos, o Consenso dos Especialistas Brasileiros (2003) recomenda a Oxarcarbazepina ou a Carbamazepina como primeira linha de tratamento para epilepsia focal sintomática em pacientes grávidas ou amamentando.',
    posologia: '900-2.400 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 300mg ou 600mg',
  },
  Clobazam: {
    drugs: '',
    observation: '',
    posologia: '10-30 mg/dia, dividido em 1-3x/dia',
    presentation: 'comp. 10mg ou 20mg',
  },
  Topiramato: {
    drugs: '',
    observation: '',
    posologia: '100-400 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 25mg ou 50mg ou 100mg',
  },
  Levetiracetam: {
    drugs: '',
    observation: '',
    posologia: '1.000-3.000mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 250mg ou 500mg ou 750mg ou 1.000mg xp. 100mg/mL',
  },
  Vigabatrina: {
    drugs: '',
    observation: '',
    posologia: '500-4.500 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 500mg',
  },
  Fenobarbital: {
    drugs: '',
    observation: '',
    posologia: '100-200mg/dia, 1x/dia',
    presentation:
      'comp. 50mg ou 100mg gotas 40mg /40gotas /1mL (cada gota contém 1mg)',
  },
  Etossuximida: {
    drugs: '',
    observation: '',
    posologia: '500-1.000 mg/dia, dividido em 2-3x/dia',
    presentation: 'xp. 50mg/1mL',
  },
  Clonazepam: {
    drugs: '',
    observation: '',
    posologia: '1-6 mg/dia, dividido em 2-3x/dia',
    presentation:
      'comp. 0,5mg ou 2mg xp. 2,5mg /26gotas /1mL (cada gota contém 0,1mg)',
  },
  Lacosamida: {
    drugs: '',
    observation: '',
    posologia: '200-600 mg/dia, dividido em 2-3x/dia',
    presentation: 'comp. 50mg ou 100mg ou 150mg ou 200mg',
  },
};

export const DrogasAntiEpileticasProvider = ({
  children,
}: PropsWithChildren) => {
  const [combination, setCombination] = useState<ICombination | null>(null);
  const [epilepsyType, setEpilepsyType] = useState<EEpilepsyType>(
    EEpilepsyType.IdiopathicGeneralizedEpilepsyTonicClonic,
  );
  const [firstLineDrugs, setFirstLineDrugs] = useState<IFirstLineDrug[]>(
    database[EPatientType.Other][
      EEpilepsyType.IdiopathicGeneralizedEpilepsyTonicClonic
    ],
  );
  const [patientType, setPatientType] = useState<EPatientType>(
    EPatientType.Other,
  );
  const [selectedFirstLineDrug, setSelectedFirstLineDrug] =
    useState<IFirstLineDrug | null>(null);

  const handleEpilepsyType = useCallback((value: EEpilepsyType): void => {
    setEpilepsyType(value);
  }, []);

  const handlePatientType = useCallback((value: EPatientType): void => {
    setPatientType(value);
  }, []);

  const handleSelectFirstLineDrug = useCallback((value: string): void => {
    const selectedCombination = combinations[value];
    setCombination(selectedCombination);
  }, []);

  const handleGetDrugs = useCallback((inputData: IGetDrugsInputData): void => {
    setSelectedFirstLineDrug(null);
    const drugs = database[inputData.patientType][inputData.epilepsyType];
    if (!drugs) {
      setFirstLineDrugs([]);
      return;
    }
    setFirstLineDrugs(drugs);
  }, []);

  return (
    <DrogasAntiEpileticasContext.Provider
      value={{
        combination,
        selectedFirstLineDrug,
        onSelectFirstLineDrug: handleSelectFirstLineDrug,
        epilepsyType,
        firstLineDrugs,
        onGetDrugs: handleGetDrugs,
        patientType,
        setEpilepsyType: handleEpilepsyType,
        setPatientType: handlePatientType,
      }}>
      {children}
    </DrogasAntiEpileticasContext.Provider>
  );
};
